/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface TypeBulletinSearchDto
 */
export interface TypeBulletinSearchDto {
    /**
     * 
     * @type {TextSearch}
     * @memberof TypeBulletinSearchDto
     */
    code?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof TypeBulletinSearchDto
     */
    libelle?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof TypeBulletinSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof TypeBulletinSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof TypeBulletinSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypeBulletinSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof TypeBulletinSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof TypeBulletinSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the TypeBulletinSearchDto interface.
 */
export function instanceOfTypeBulletinSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TypeBulletinSearchDtoFromJSON(json: any): TypeBulletinSearchDto {
    return TypeBulletinSearchDtoFromJSONTyped(json, false);
}

export function TypeBulletinSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeBulletinSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : TextSearchFromJSON(json['code']),
        'libelle': !exists(json, 'libelle') ? undefined : TextSearchFromJSON(json['libelle']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function TypeBulletinSearchDtoToJSON(value?: TypeBulletinSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': TextSearchToJSON(value.code),
        'libelle': TextSearchToJSON(value.libelle),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

